exports.submitUserPreferencesIfInvalid = (userPreferences) => {

    const hasErrors = !!userPreferences && userPreferences.fields.some(userPreferences.validate);

    if (hasErrors) {
        userPreferences.submit();
    }

    return hasErrors;
};

exports.buildSubmitValidationState = ({
    fields = [],
    validate,
    userPreferences
}) => {

    return {
        hasErrors: fields.some(validate),
        userPreferencesHasErrors: exports.submitUserPreferencesIfInvalid(userPreferences)
    };
};
